/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespContentModuleRegular_browseContentModule$ref = any;
type SbSharedContentModuleBanner_browseContentModule$ref = any;
type SbSharedContentModulePromo_browseContentModule$ref = any;
export type SbRespContentModuleSelector_itemSearch$ref = any;
export type SbRespContentModuleSelector_itemSearch = {
    readonly browseContentModule: {
        readonly moduleType: string | null;
        readonly " $fragmentRefs": SbRespContentModuleRegular_browseContentModule$ref & SbSharedContentModuleBanner_browseContentModule$ref & SbSharedContentModulePromo_browseContentModule$ref;
    } | null;
    readonly " $refType": SbRespContentModuleSelector_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespContentModuleSelector_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "browseContentModule",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "moduleType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespContentModuleRegular_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBanner_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModulePromo_browseContentModule",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '891f1d72af9772df9ef3dd118ca28ba7';
export default node;
